import { useState } from 'react';
import { Box } from '@material-ui/core';
import { makeStyles, Theme } from '@material-ui/core/styles';
import { Add } from '@material-ui/icons';
import { useBaseStore, useUserStore } from '@roc/feature-app-core';
import { DocumentForms, useDocumentStore } from '@roc/feature-documents';
import { Button, Paper, PDFPreview } from '@roc/ui';
import { observer } from 'mobx-react';
import { useEffect } from 'react';
import { GeneralTasksToolbar } from '../components/generalTasksToolbar';
import { useGeneralTasksStore } from '../hooks/useGeneralTasksStore';
import { AddLoanTaskDialog } from './addLoanTask/addLoanTaskDialog';
import {
  GeneralTasksTab,
  GeneralTasksView
} from '../types/generalTasksTypes';
import { EditTaskDialog } from './editTask/editTaskDialog';
import { KanbanView } from './kanbanView';
import { TaskListView } from './taskListView';
import { LOAN_RELATED_DOCUMENTS, LOAN_RELATED_DOCUMENTS_ID } from '../utils/generalTasksConstants';


const useStyles = makeStyles((theme: Theme) => ({
  paper: {
    padding: theme.spacing(2),
    boxShadow: 'none !important',
    border: '1px solid #cdcdcd',
  }
}))

export const GeneralTasksComponent = observer(({ teamScopeOnly = false }) => {
  const classes = useStyles();
  const { generalTasksStore } = useGeneralTasksStore();
  const { globalStore } = useBaseStore();
  const { userStore } = useUserStore();
  const { documentStore } = useDocumentStore();
  const { tab, view, editTaskStore } = generalTasksStore;
  const { loanId } = generalTasksStore;
  const [addDialogOpen, setAddDialogOpen] = useState(false);

  useEffect(() => {
    userStore.getUserInfoAndEntitlements();
  }, []);

  const onClose = () => {
    if (generalTasksStore.tab !== GeneralTasksTab.ALL_TASKS_FOR_LOAN) {
      generalTasksStore.setLoanId(null);
    }
    generalTasksStore.applyFilters();
  };

  return (
    <>
      <Box display="flex" flexDirection="column" height="100%" flex="1">
        <Box pb={2}>
          <Paper className={classes.paper}>
            <GeneralTasksToolbar teamScopeOnly={teamScopeOnly} />
          </Paper>
        </Box>
        <Box flex={1} display="flex" flexDirection="column">
          <Paper className={classes.paper} style={{ flex: "1", display: "flex", flexDirection: "column" }}>
            <Box pb={2} textAlign={'right'}>
              <Button
                testId="add-task"
                variant="contained"
                color="primary"
                size="small"
                onClick={() => setAddDialogOpen(true)}
              >
                <Add />
                New Task
              </Button>
            </Box>
            {view === GeneralTasksView.KANBAN && <KanbanView />}
            {view === GeneralTasksView.LIST && <TaskListView />}
          </Paper>
        </Box>
      </Box>
      <EditTaskDialog />
      <AddLoanTaskDialog
        open={addDialogOpen}
        loanId={loanId}
        handleClose={() => {
          setAddDialogOpen(false)
          generalTasksStore.applyFilters();
        }}
        sectionName={globalStore.isInternalPortal ? null : LOAN_RELATED_DOCUMENTS}
        sectionId={globalStore.isInternalPortal ? null : LOAN_RELATED_DOCUMENTS_ID}
        options={editTaskStore.loanTaskSectionNames.map(category => ({ value: category.taskCategoryId, label: category.displayName }))}
      />
      {loanId && globalStore.userFeatures && (
        <>
          <DocumentForms
            loanId={loanId?.toString()}
            onClose={() => onClose()}
          />
          <PDFPreview
            open={documentStore.documentPreview != null}
            title={documentStore.documentPreview?.title}
            data={documentStore.documentPreview?.data}
            dataV2={documentStore.documentPreview?.data}
            headers={documentStore.documentPreview?.headers}
            onClose={() => {
              onClose();
              documentStore.closeDocumentPreview();
            }}
          />
        </>
      )}
    </>
  );
});
